import { render, staticRenderFns } from "./registration-form.vue?vue&type=template&id=a60230d2&"
import script from "./registration-form.vue?vue&type=script&lang=js&"
export * from "./registration-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports